import React from "react";
import "./index.scss";
import { CircleUnfilledCheck } from "../../../../../assets/images/svg/svg";

const InsuranceDetails = ({ productInfo, isVisible }) => {
  return (
    <>
      {productInfo.Attributes.length > 0 && (
        <div className="insurance--detail--wrapper">
          <div className="details--wrapper--header">
            <div className="details--header--title">
              <h1 className="details--header--title--text">Coverages</h1>
            </div>
            <div className="details--header--count">
              {productInfo.Attributes.length}
            </div>
          </div>
          {isVisible && (
            <div className="details--body--wrapper">
              <ul className="body--list">
                <>
                  {productInfo.Attributes?.map((list, index) => (
                    <li key={index}>
                      <CircleUnfilledCheck />
                      <span className="body--list--text">
                        {list.label} : {list.value}
                      </span>
                    </li>
                  ))}
                </>
              </ul>
            </div>
          )}
        </div>
      )}
      {productInfo.Add_Ons.length > 0 && (
        <div className="insurance--detail--wrapper">
          <div className="details--wrapper--header">
            <div className="details--header--title">
              <h1 className="details--header--title--text">Add ons</h1>
            </div>
            <div className="details--header--count">
              {productInfo.Add_Ons.length}
            </div>
          </div>
          {isVisible && (
            <div className="details--body--wrapper">
              <ul className="body--list">
                <>
                  {productInfo.Add_Ons?.map(
                    (list, index) =>
                      list.value !== "no" && (
                        <li key={index}>
                          <CircleUnfilledCheck />
                          <span className="body--list--text">
                            {list.label}: {list.value}
                          </span>
                        </li>
                      )
                  )}
                </>
              </ul>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default InsuranceDetails;
